import { render, staticRenderFns } from "./TextColumn.vue?vue&type=template&id=15ecf748&scoped=true&"
import script from "./TextColumn.vue?vue&type=script&lang=js&"
export * from "./TextColumn.vue?vue&type=script&lang=js&"
import style0 from "./TextColumn.vue?vue&type=style&index=0&id=15ecf748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ecf748",
  null
  
)

export default component.exports